import { TimelineMax } from 'gsap/all';
import { contentSizingAjustments } from '../helperFunc.js';

let loadedCount = 0; // current number of images loaded
let loadingProgress = 0; // timeline progress - starts at 0

let progressUpdate = () => {
	loadingProgress = Math.round(progressTl.progress() * 100); // the percentage loaded based on the tween's progress
	$('.txt-perc').text(`${loadingProgress}%`); // we put the percentage in the screen
}

let loadComplete = () => {
	contentSizingAjustments();

	let preloaderOutTl = new TimelineMax();
	preloaderOutTl
		.to($('.progress'), 0.3, { y: 100, autoAlpha: 0, ease: Back.easeIn })
		.to($('.txt-perc'), 0.3, { y: 100, autoAlpha: 0, ease: Back.easeIn }, 0)
		.set($('body'), { className: '-=is-loading' })
		.set($('#main > article:first-of-type'), { className: '+=is-loaded' })
		.to($('#preloader'), 0.7, { yPercent: 100, ease: Power4.easeInOut })
		.set($('#preloader'), { className: '+=is-hidden' })
	;
	return preloaderOutTl;
}


// progress animation instance. the instance's time is irrelevant, can be anything but 0 to void  immediate render
let progressTl = new TimelineMax({ paused: true, onUpdate: progressUpdate, onComplete: loadComplete })
	.to($('.progress span'), 1, { height: 100, ease: Linear.easeNone }) // tween the progress bar height
;

// let progressTl = new TimelineMax({ paused: true, onUpdate: progressUpdate, onComplete: loadComplete }).to($('.progress span'), 1, { width: 100, ease: Linear.easeNone }); // tween the progress bar width

export default function (totalToLoad) {
	loadedCount++; // one more image has been loaded
	loadingProgress = (loadedCount/totalToLoad);
	TweenLite.to(progressTl, 0.7, { progress: loadingProgress, ease: Linear.easeNone }); // GSAP timeline for our progress bar
}




// export default function (empty = false) {
// 	if (empty) {
// 		loadComplete();
// 	} else {
// 		loadedCount++; // one more image has been loaded
// 		loadingProgress = (loadedCount/imagesToLoad);
// 		TweenLite.to(progressTl, 0.7, { progress: loadingProgress, ease: Linear.easeNone }); // GSAP timeline for our progress bar
// 	}
// }
